import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardList, Plus, Zap } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage, ukDate } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useOrder } from "../context/OrderContext";
import { PageHeader, EmptyState } from "../components/Shared";
import { Button } from "../components/ui/button";
import { OrderStatus } from "./OrderDetail";

export default function Orders() {
  const { restaurantId } = useAuth();
  const { count } = useOrder();
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get("/ordering/orders", { params: { restaurant_id: restaurantId || undefined } }).then((r) => setOrders(r.data)).catch((e) => toast.error(errorMessage(e))); }, [restaurantId]);

  return (
    <div data-testid="orders-page" className="max-w-3xl">
      <PageHeader title="Orders" subtitle="Order history for this restaurant." actions={<>
        <Button asChild variant="outline" className="h-11"><Link to="/order/quick" data-testid="quick-order-link"><Zap className="h-4 w-4 mr-1.5" /> Quick Order</Link></Button>
        <Button asChild className="h-11 bg-emerald-600 hover:bg-emerald-700"><Link to="/order" data-testid="new-order-link"><Plus className="h-4 w-4 mr-1.5" /> New Order</Link></Button>
      </>} />
      {count > 0 && <Link to="/order/review" className="block mb-4 bg-amber-50 border border-amber-300 text-amber-900 rounded-xl px-4 py-3 text-sm font-medium" data-testid="continue-order-banner">You have an unfinished order ({count} items) — Continue Order →</Link>}
      {orders === null ? <p className="text-sm text-slate-500">Loading…</p> : orders.length === 0 ? (
        <EmptyState icon={ClipboardList} title="No orders yet" hint="Create your first order — it takes a few taps." testId="orders-empty" action={<Button asChild className="bg-emerald-600"><Link to="/order">New Order</Link></Button>} />
      ) : (
        <ul className="space-y-2" data-testid="orders-list">
          {orders.map((o) => (
            <li key={o.id}>
              <Link to={`/orders/${o.id}`} className="block bg-white border border-slate-200 rounded-xl p-4 active:bg-slate-50" data-testid={`order-row-${o.id}`}>
                <div className="flex items-center justify-between gap-2"><p className="font-semibold text-slate-900">{ukDate(o.created_at)}</p><OrderStatus status={o.status} /></div>
                <p className="text-sm text-slate-600 mt-1 truncate">{o.supplier_names.join(", ")}</p>
                <p className="text-xs text-slate-400 mt-0.5">{o.totals.item_count} items · {o.totals.supplier_count} supplier{o.totals.supplier_count === 1 ? "" : "s"} · by {o.created_by_name}</p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
